import React, { useState, KeyboardEvent, ClipboardEvent } from 'react';
import Chip from './Chip';
import { Form } from 'react-bootstrap';

interface EmailInputProps {
    emails: string[];
    onEmailsChanged: (emails: string[]) => void;
    placeholder?: string;
}

const EmailInput: React.FC<EmailInputProps> = ({ emails, onEmailsChanged, placeholder }) => {
    const [inputValue, setInputValue] = useState('');

    const addEmails = (newEmails: string[]) => {
        const filtered = newEmails
            .map(email => email.trim())
            .filter(email => email.length > 0 && email.includes('@') && !emails.includes(email));

        if (filtered.length > 0) {
            onEmailsChanged([...emails, ...filtered]);
        }
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (['Enter', 'Tab', ','].includes(e.key)) {
            e.preventDefault();
            addEmails([inputValue]);
            setInputValue('');
        } else if (e.key === 'Backspace' && !inputValue && emails.length > 0) {
            const newEmails = [...emails];
            newEmails.pop();
            onEmailsChanged(newEmails);
        }
    };

    const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData('text');
        const pastedEmails = pasteData.split(/[\s,;]+/);
        addEmails(pastedEmails);
    };

    const removeEmail = (index: number) => {
        const newEmails = [...emails];
        newEmails.splice(index, 1);
        onEmailsChanged(newEmails);
    };

    return (
        <div style={{
            border: '1px solid #ced4da',
            borderRadius: '4px',
            padding: '5px',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            minHeight: '38px',
            backgroundColor: '#fff'
        }}>
            {emails.map((email, index) => (
                <Chip key={`${email}-${index}`} label={email} onDelete={() => removeEmail(index)} />
            ))}
            <input
                type="text"
                value={inputValue}
                placeholder={emails.length === 0 ? placeholder : ''}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
                onPaste={handlePaste}
                onBlur={() => {
                    if (inputValue) {
                        addEmails([inputValue]);
                        setInputValue('');
                    }
                }}
                style={{
                    border: 'none',
                    outline: 'none',
                    flex: '1',
                    minWidth: '120px',
                    padding: '5px',
                    fontSize: '16px'
                }}
            />
        </div>
    );
};

export default EmailInput;
